export const ORDER_GRID_COMBINE_ORDERS = 'ORDER_GRID_COMBINE_ORDERS';
export const ORDER_GRID_VALIDATE_ADDRESS = 'ORDER_GRID_VALIDATE_ADDRESS';
export const ORDER_GRID_OPEN_MARK_SHIPPED_MODAL = 'ORDER_GRID_OPEN_MARK_SHIPPED_MODAL';
export const ORDER_GRID_GET_RATES = 'ORDER_GRID_GET_RATES';
export const ORDER_GRID_GET_RATES_REQUEST = 'ORDER_GRID_GET_RATES_REQUEST';
export const ORDER_GRID_GET_RATES_SUCCESS = 'ORDER_GRID_GET_RATES_SUCCESS';
export const ORDER_GRID_GET_RATES_FAILURE = 'ORDER_GRID_GET_RATES_FAILURE';
export const ORDER_GRID_RATES_UPDATED = 'ORDER_GRID_RATES_UPDATED';
export const ORDER_GRID_RATES_CLEAR = 'ORDER_GRID_RATES_CLEAR';

export const orderGridCombineOrders = () => {
  return {
    type: ORDER_GRID_COMBINE_ORDERS,
  };
};

export const orderGridValidateAddress = () => ({
  type: ORDER_GRID_VALIDATE_ADDRESS,
});

export const orderGridOpenMarkShippedModal = (page) => ({
  type: ORDER_GRID_OPEN_MARK_SHIPPED_MODAL,
  page,
});

export const orderGridGetRates = () => ({
  type: ORDER_GRID_GET_RATES,
});

export const orderGridGetRatesRequest = (fulfillmentPlanIds, filters) => ({
  type: ORDER_GRID_GET_RATES_REQUEST,
  fulfillmentPlanIds,
  filters,
});

export const orderGridGetRatesSuccess = (response) => ({
  type: ORDER_GRID_GET_RATES_SUCCESS,
  response,
});

export const orderGridGetRatesFailure = (error) => ({
  type: ORDER_GRID_GET_RATES_FAILURE,
  error,
});

export const orderGridRatesUpdated = (data) => ({
  type: ORDER_GRID_RATES_UPDATED,
  data,
});

export const orderGridClearGetRates = () => ({
  type: ORDER_GRID_RATES_CLEAR,
});

export const OPEN_ADD_SALES_ORDER_TO_BATCH_FROM_ORDERS_GRID = 'OPEN_ADD_SALES_ORDER_TO_BATCH_FROM_ORDERS_GRID';
export const openAddSalesOrderToBatchFromOrdersGrid = (filters) => ({
  type: OPEN_ADD_SALES_ORDER_TO_BATCH_FROM_ORDERS_GRID,
  filters,
});

export const ADD_SALES_ORDERS_TO_BATCH_FROM_ORDERS_GRID = 'ADD_SALES_ORDERS_TO_BATCH_FROM_ORDERS_GRID';
export const addSalesOrderToBatchFromOrderGrid = (fulfillmentPlanSetId, filters) => ({
  type: ADD_SALES_ORDERS_TO_BATCH_FROM_ORDERS_GRID,
  fulfillmentPlanSetId,
  filters,
});
